// extracted by mini-css-extract-plugin
export var container = "Expandable-module__container___bahvb";
export var collapsible = "Expandable-module__collapsible___HbECD";
export var collapsed = "Expandable-module__collapsed___q9sHd";
export var control = "Expandable-module__control___P3Sp0";
export var toggleButton = "Expandable-module__toggleButton___XPCpQ";